import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Paragraph from '../../../../shared/components/Paragraph';
import VoiceLink from '../../../../shared/components/Link';
import List from '../../../../shared/components/List';

function Warning({ email }) {
  const { t } = useTranslation();

  return (
    <>
      {
        email
          ? (
            <>
              <Paragraph>
                {t('mail_warning_p_1')}
              </Paragraph>
              <List>
                <li>
                  {t('mail_warning_list_1_start')}
                  <VoiceLink
                    href={window.location.href}
                    color="primary"
                    small
                  >
                    {window.location.href}
                  </VoiceLink>
                  {t('mail_warning_list_1_end')}
                </li>
                <li>{t('mail_warning_list_2')}</li>
                <li>{t('mail_warning_list_3')}</li>
              </List>
            </>
          ) : (
            <Paragraph>
            </Paragraph>
          )
      }
    </>
  );
}

Warning.defaultProps = {
  email: false,
};

Warning.propTypes = {
  email: PropTypes.bool,

};

export default Warning;
